<template>
  <div class="card-container">
    <div class="full" id="full-width">
      <p class="card-title" @mousemove="onMouseOver">
        <span v-html="cardTitle"></span>
      </p>
      <div :id="titleId" class="tooltips"><span v-html="cardTitle"></span></div>
    </div>

    <slot v-if="!isEmpty && choosenAnswers.length > 0" name="body"></slot>
    <div class="row no-data-in" v-else>
      <div class="col-md-10 no-data-in__content ">
        <span class="no-data-in-text">No Data In</span>
      </div>
      <ChartLegend :primaryColor="primaryColor" :participantName="participantName"></ChartLegend>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
import ChartLegend from "./chart-legend-card";
export default {
  props: {
    titleId: [String],
    cardTitle: [String],
    isEmptyData: { type: Boolean, default: false },
    primaryColor: { type: String, default: "" },
    participantName: { type: String, default: "" },
    choosenAnswers: [Array, null]
  },
  components: {
    ChartLegend
  },

  data() {
    return {
      isEmpty: false
    };
  },

  methods: {
    onMouseOver(evt) {
      const tooltips = document.getElementById(this.titleId);

      if (tooltips) {
        tooltips.style.left = `${this.getMousePosition(evt).x}px`;
        tooltips.style.top = "25px";
      }
    },

    getMousePosition(evt) {
      const event = evt || window.event;
      const fullWidth = document.getElementById("full-width");
      let mousePos = {};

      if (event.pageX == null && event.clientX != null) {
        const eventDoc = (event.target && event.target.ownerDocument) || document;
        const doc = eventDoc.documentElement;
        const body = eventDoc.body;

        event.pageX = event.clientX + ((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) - ((doc && doc.clientLeft) || (body && body.clientLeft) || 0);
      }

      mousePos = {
        x: event.pageX - fullWidth.offsetLeft,
        y: event.pageY
      };
      return mousePos;
    }
  },

  watch: {
    isEmptyData: function(val) {
      this.isEmpty = val;
    }
  }
};
</script>
<style lang="scss">
.card-container {
  background-color: white;
  border-radius: 4px;
  padding: 15px 13px;
  border: solid 1px #c5d1d6;
  margin-bottom: 16px;
  height: 450px;
  max-height: 450px;
  overflow: hidden;
}

.card-container:last-child {
  margin-bottom: 0;
}

.full {
  position: relative;
  width: 100%;
}

.full-height {
  height: 350px;
}

.card-title {
  display: inline-block;
  font-family: "Roboto-medium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  white-space: nowrap;
  max-width: 99%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.no-data-in {
  justify-content: center;
  transform: translate(10px, 157px);
  margin-left: -39px !important;
  .no-data-in-text {
    display: inline-block;
    margin-top: -20px;
  }
  .no-data-in__content {
    text-align: center;
  }
}

.tooltips {
  visibility: hidden;
  opacity: 0;

  font-family: RobotoRegular;
  font-size: 12px;
  color: #666669;

  display: inline-block;
  background-color: #fff;
  border-radius: 4px;
  padding: 4px 7px;

  position: absolute;
  max-width: 250px;
  width: max-content;

  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
}

.card-title:hover + .tooltips {
  visibility: visible;
  opacity: 1;
  z-index: 100;
}
</style>
